import states from '../states';

require.ensure(['scrollmagic-core', 'scrollmagic-gsap'], () => {
  const ScrollMagic = require('scrollmagic-core');
  require('scrollmagic-gsap');

  // init ScrollMagic controller
  const section = new ScrollMagic.Controller();

  // declare ScrollMagic scene variables
  let fixedDesktopScene = null;
  let fixedMobileScene = null;

  const initMobile = function initMobile() {
    const $fixedProduct = $('.product-top .ps-widget');

    if ($fixedProduct.length) {
      fixedMobileScene = new ScrollMagic.Scene({ triggerElement: '.product-top .review-info' })
      // trigger animation by adding a css class
        .setClassToggle('.product-top .ps-widget', 'fixed').triggerHook('onLeave').addTo(section);
    }
  };

  const initDesktop = function initDesktop() {
    const $psWidget = $('.product-top .ps-widget');
    const $fixedProduct = $('.js-fixed-product-details');
    const $headerDrop = $('.header-drop');

    if ($psWidget.length && $fixedProduct.length) {
      $fixedProduct.show();

      fixedDesktopScene = new ScrollMagic.Scene({ triggerElement: '.product-nav' })
      // trigger animation by adding a css class
        .setClassToggle('.js-fixed-product-details', 'open').addTo(section);

      // has to be done like this due to the animation of the sticky nav
      setInterval(() => {
        const navheight = $headerDrop.outerHeight();
        $fixedProduct.css('top', navheight);
      }, 1);
    }
  };

  const destroyMobile = function destroyMobile() {
    if (fixedMobileScene != null) {
      fixedMobileScene.destroy(true);
      fixedMobileScene = null;
    }
  };

  const destroyDesktop = function destroyDesktop() {
    if (fixedDesktopScene != null) {
      fixedDesktopScene.destroy(true);
      fixedDesktopScene = null;
    }
    $('.js-fixed-product-details').removeAttr('style');
  };

  // Handle mobile states.
  states.getState('xs').on('enter', () => {
    destroyDesktop();
    initMobile();
  });
  states.getState('sm').on('enter', () => {
    destroyDesktop();
    initMobile();
  });

  // Handle desktop states.
  states.getState('md').on('enter', () => {
    destroyMobile();
    initDesktop();
  });
  states.getState('lg').on('enter', () => {
    destroyMobile();
    initDesktop();
  });

  setTimeout(() => {
    // Initialise navigation.
    if (states.isActive('xs') || states.isActive('sm')) {
      initMobile();
    } else {
      initDesktop();
    }
  }, 1000);
});
